// Core imports
import * as React from 'react';
import localeFormating from 'src/translation/localeFormating';

// Components imports
import Input from 'src/components/common/Input';

// Models imports
import InvoiceModel from 'src/model/invoice.model';
import { IInvoicePaymentData } from '../PaymentMode/PaymentModeDesktop';

// Style and misc imports
import './PayInvoiceRow.scss';

class PayInvoiceRow extends React.Component<
  IPayInvoiceRowProps,
  IPayInvoiceRowState
> {
  constructor(props: IPayInvoiceRowProps) {
    super(props);

    this.state = {
      paymentAmount: '',
      remaining: '0',
      notes: ''
    };
  }

  /* 
    handlePaymentAmount
   */
  private handlePaymentAmount = (input: any) => {
    const value = input;
    let maxPayment = 0;
    let remaining = 0;
    let payment = 0;
    if (this.props.invoice.remainingAmount < 0) {
      maxPayment = this.props.invoice.remainingAmount * -1;
      remaining =
        (value <= maxPayment && value >= 0
          ? value
          : value === '-'
          ? 0
          : maxPayment) - maxPayment;
      payment = value <= maxPayment && value >= 0 ? value : maxPayment;
    } else {
      maxPayment = this.props.invoice.remainingAmount;
      remaining =
        ((value <= maxPayment ? value : maxPayment) - maxPayment) * -1;

      if ((value <= maxPayment && value >= 0) || value.startsWith('.')) {
        payment = value;
      } else {
        payment = maxPayment;
      }
    }

    this.setState(
      {
        paymentAmount: payment.toString(),
        remaining: remaining.toString()
      },
      () => {
        const paymentData: IInvoicePaymentData = {
          transactionId: this.props.invoice.transactionId,
          invoiceDate: this.props.invoice.invoiceDate,
          invoiceNumber: this.props.invoice.invoiceNumber,
          orderNumber: this.props.invoice.orderNumber,
          payment: parseFloat(
            this.props.invoice.remainingAmount < 0
              ? (payment * -1).toString()
              : payment.toString()
          ),
          remaining: parseFloat(this.state.remaining),
          total: this.props.invoice.remainingAmount,
          notes: this.state.notes
        };
        this.props.onDataChange(paymentData);
      }
    );
  };

  /* 
    handleNotes
   */
  private handleNotes = (event: any) => {
    this.setState(
      {
        notes: event
      },
      () => {
        const paymentData: IInvoicePaymentData = {
          transactionId: this.props.invoice.transactionId,
          invoiceDate: this.props.invoice.invoiceDate,
          invoiceNumber: this.props.invoice.invoiceNumber,
          orderNumber: this.props.invoice.orderNumber,
          payment: parseFloat(this.state.paymentAmount),
          remaining: parseFloat(this.state.remaining),
          total: this.props.invoice.remainingAmount,
          notes: this.state.notes
        };
        this.props.onDataChange(paymentData);
      }
    );
  };

  public componentDidMount() {
    this.setState({
      paymentAmount:
        this.props.invoice.remainingAmount < 0
          ? (this.props.invoice.remainingAmount * -1).toString()
          : this.props.invoice.remainingAmount.toString(),
      remaining: '0'
    });
  }

  public render() {
    const { t, invoice } = this.props;
    const { invoiceNumber, remainingAmount } = invoice;

    return (
      <div className="rp-pay-invoice-row">
        <div className="invoice-data--number">{invoiceNumber}</div>
        <div className="invoice-data--invoice-total">
          {localeFormating.formatCurrency(remainingAmount)}
        </div>
        <div className="invoice-data--amount-to-pay">
          <Input
            value={this.state.paymentAmount.toString()}
            onChange={this.handlePaymentAmount}
          />
        </div>
        <div className="invoice-data--remaining-amount">
          {localeFormating.formatCurrency(parseFloat(this.state.remaining))}
        </div>
        <div className="invoice-data--notes">
          {parseFloat(this.state.paymentAmount.toString()) <
            parseFloat(invoice.remainingAmount.toString()) &&
          parseFloat(invoice.remainingAmount.toString()) > 0 ? (
            <Input
              value={this.state.notes}
              onChange={this.handleNotes}
              invalid={!this.state.notes}
              invalidMessage={'Required field.'}
            />
          ) : (
            <React.Fragment />
          )}
        </div>
      </div>
    );
  }
}

export default PayInvoiceRow;

interface IPayInvoiceRowProps {
  onDataChange(invoices: IInvoicePaymentData): void;
  t: any;
  invoice: InvoiceModel;
}

interface IPayInvoiceRowState {
  paymentAmount: string;
  remaining: string;
  notes: string;
}
